import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useProducts } from "../context/ProductContext";
import ProductCard from "../components/ProductCard";
import AccountDetailsPopup from "../components/AccountDetailsPopup";

const CategoryPage = () => {
  const { categoryId } = useParams();
  const { products, categories } = useProducts();
  const category = categories.find((c) => c.id === categoryId);
  const categoryProducts = products.filter((p) => p.category === categoryId);
  const [showAccountPopup, setShowAccountPopup] = useState(false);

  const handleWhatsAppClick = (product, variant, quantity) => {
    const accountDetails = localStorage.getItem("accountDetails");
    if (!accountDetails) {
      setShowAccountPopup(true);
      return;
    }

    const account = JSON.parse(accountDetails);
    const qty = quantity > 0 ? quantity : 1;
    const totalPrice = variant.offerPrice * qty;

    let message = `🛒 *NEW ORDER REQUEST*\n\n`;
    message += `📦 *Product Details:*\n`;
    message += `─────────────────\n`;
    message += `${product.name}\n`;
    message += `📏 Size: ${variant.size}\n`;
    message += `🔢 Quantity: ${qty}\n`;
    message += `💰 Price per unit: ₹${variant.offerPrice}\n`;
    message += `─────────────────\n`;
    message += `💵 *Total: ₹${totalPrice}*\n\n`;

    message += `📍 *Delivery Details:*\n`;
    message += `─────────────────\n`;
    message += `👤 Name: ${account.name || "N/A"}\n`;
    message += `📱 Mobile: ${account.mobile}\n`;
    message += `📧 Email: ${account.email || "N/A"}\n`;
    message += `🏠 Address:\n`;
    message += `   ${account.addressLine1}\n`;
    if (account.addressLine2) message += `   ${account.addressLine2}\n`;
    if (account.addressLine3) message += `   ${account.addressLine3}\n`;
    message += `   ${account.city}, ${account.state} - ${account.pincode}\n\n`;
    message += `*Additional shipping charges applicable.*\n`;

    const whatsappUrl = `https://wa.me/919840453354?text=${encodeURIComponent(
      message,
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Category not found
          </h2>
          <Link to="/" className="text-green-600 hover:underline">
            Go back to home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <Link
          to="/"
          className="text-green-600 hover:underline mb-4 inline-block"
        >
          ← Back to home
        </Link>

        <div className="bg-gradient-to-r from-green-400 to-red-400 text-white rounded-lg p-8 mb-8 text-center">
          <div className="text-6xl mb-4">{category.icon}</div>
          <h1 className="text-4xl font-bold">{category.name}</h1>
        </div>

        {categoryProducts.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {categoryProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onWhatsAppClick={handleWhatsAppClick}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-xl text-gray-600">
              No products available in this category
            </p>
          </div>
        )}
      </div>
      <AccountDetailsPopup
        isOpen={showAccountPopup}
        onClose={() => setShowAccountPopup(false)}
      />
    </div>
  );
};

export default CategoryPage;
